module.exports = __webpack_public_path__ + "media/images/application/template/search-2df646adc655376efb5b24bc2e620672.svg";